<script>
import { getFlightConfig } from '@utils/helpers.js'

import moment from 'moment'
import _ from 'underscore'

export default {
  data() {
    return {
      paxTotalsView: 'booked',
    }
  },
  props: {
    flight: {
      type: Object,
      required: true,
    },
  },
  computed: {
    bayData() {
      return this.$store.getters['bays/getBayDataByFltId'](this.flight.FlightId)
    },
    paxTotalsData() {
      return this.$store.getters['paxTotals/getPaxTotalsByFltId'](
        this.flight.FlightId
      )
    },
    ACI() {
      console.log('ACI', this.paxTotalsData)
      return {
        A: _.reduce(
          this.paxTotalsData,
          (memo, obj) => {
            if(this.paxTotalsView === 'booked') {
              return memo + obj.TotalAdult
            } else {
              return memo + (obj.CkdMale + obj.CkdFemale)
            }

          },
          0
        ),
        C: _.reduce(
          this.paxTotalsData,
          (memo, obj) => {
            if(this.paxTotalsView === 'booked') {
              return memo + obj.TotalChild
            } else {
              return memo + obj.CkdChild
            }
          },
          0
        ),
        I: _.reduce(
          this.paxTotalsData,
          (memo, obj) => {
            if(this.paxTotalsView === 'booked') {
              return memo + obj.TotalInfant
            } else {
              return memo + obj.CkdInfant
            }
          },
          0
        ),
      }
    },
    baySplitTotals() {
      const bays = _.groupBy(this.bayData, 'BayNumber')
      const returnData = {}
      Object.keys(bays) // get the keys as array
        .forEach(function(key, index) {
          returnData[key] = _.reduce(
            bays[key],
            (memo, obj) => {
              return memo + (obj.CkdAdult + obj.CkdChild)
            },
            0
          )
        })
      return returnData
    },
    groupedDestBayMFCI() {
      return _.groupBy(this.bayData, 'Destination')
    },
    groupedDestBagTotals() {
      return _.groupBy(this.bayData, 'Destination')
    },
    destinationSplitTotals() {
      const destinations = _.groupBy(this.bayData, 'Destination')
      const returnData = {}
      Object.keys(destinations).forEach(function(key, index) {
        returnData[key] = {
          TotalPieces: _.reduce(
            destinations[key],
            (memo, obj) => {
              return memo + obj.TotalPieces
            },
            0
          ),
          TotalWeight: _.reduce(
            destinations[key],
            (memo, obj) => {
              return memo + obj.TotalWeight
            },
            0
          ),
        }
      })
      return returnData
    },
    MFCI() {
      return {
        M: _.reduce(
          this.bayData,
          (memo, obj) => {
            return memo + obj.CkdMale
          },
          0
        ),
        F: _.reduce(
          this.bayData,
          (memo, obj) => {
            return memo + obj.CkdFemale
          },
          0
        ),

        C: _.reduce(
          this.bayData,
          (memo, obj) => {
            return memo + obj.CkdChild
          },
          0
        ),
        I: _.reduce(
          this.bayData,
          (memo, obj) => {
            return memo + obj.CkdInfant
          },
          0
        ),
      }
    },
  },
  watch: {
    'flight.FlightId': {
      handler() {
        this.getBayData()
      },
    },
    'flight.FlightStatus': {
    immediate: true,
      handler(status) {
        if(status === 'SCHEDULED' || status === 'OPEN') {
          this.paxTotalsView = 'booked';
        } else {
          this.paxTotalsView = 'checked';
        }
      },
    },
  },
  mounted() {
    this.getBayData()
  },
  methods: {
    getFlightConfig: getFlightConfig,
    moment(datetime, format) {
      return moment(datetime).format(format)
    },
    getBayData() {
      this.$store.dispatch('bays/GET_BAY_DATA', this.flight.FlightId)
      this.$store.dispatch('paxTotals/GET_DATA', this.flight.FlightId)
    },
    getReducedMFCI(data) {
      return {
        M: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.CkdMale
          },
          0
        ),
        F: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.CkdFemale
          },
          0
        ),

        C: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.CkdChild
          },
          0
        ),
        I: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.CkdInfant
          },
          0
        ),
      }
    },
    getReducedBagTotals(data) {
      return {
        totalPieces: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.TotalPieces
          },
          0
        ),
        totalWeight: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.TotalWeight
          },
          0
        ),
      }
    },
  },
}
</script>

<template>
  <div class="app-sidebar-top text-right text-monospace">
    <p class>
      <span class="text-lg">
        {{ flight.FlightNumber }}/{{
          moment(flight.Std, 'DDMMM').toUpperCase()
        }}
      </span>
      <br />
      ROUTING {{ flight.Destinations }}
      <br />
      EQP {{ flight.Equipment }} {{ flight.Registration }}
      {{ getFlightConfig(flight) }}
      <b class="text-info">{{
        flight.SeatAllocation === 'FREE' ? 'FREE SEATING' : null
      }}</b>
      <br />
      {{ flight.Etd ? 'STD/ETD' : 'STD' }}
      {{ moment(flight.Std, 'HH:mm') }} {{ flight.Etd ? '/' : '' }}
      {{ flight.Etd ? moment(flight.Etd, 'HH:mm') : '' }}
      <br />STATUS
      <span class="flight-status" :class="flight.FlightStatus.toLowerCase()">{{
        flight.FlightStatus
      }}</span>
    </p>
    <!-- <p class="mt-4 mb-3 text-uppercase">Passenger Summary</p> -->
    <hr data-v-10f57108="">

    <div style="width: 100%; display: flex; justify-content: flex-end;">
      <ul class="nav nav-tabs nav-justified mt-1 mb-2" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link small"
            :class="paxTotalsView === 'booked' ? 'active' : ''"
            data-toggle="tab"
            role="tab"
            @click="paxTotalsView = 'booked'"
            >Booked</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link"
            :class="paxTotalsView === 'checked' ? 'active' : ''"
            data-toggle="tab"
            role="tab"
            @click="paxTotalsView = 'checked'"
            >Checked</a
          >
        </li>
      </ul>
    </div>

    <div v-if="paxTotalsView === 'booked'">
      <h6  style="margin: 0">Booked Pax Totals</h6>
      <table class="table totals table-hover small-table mt-1">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col" class="br">A</th>
            <th scope="col" class="br">C</th>
            <th scope="col" class="br">I</th>
            <th scope="col">BAG</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bt no-hover">
            <td rowspan="5" class="bt no-hover">TOTAL</td>
          </tr>
          <tr>
            <td class="br">{{ ACI['A'] || '0' }}</td>
            <td class="br">{{ ACI['C'] || '0' }}</td>
            <td class="br">{{ ACI['I'] || '0' }}</td>
            <td>
              <div class="fw-600">
                <!-- {{ totalBaggage }} -->
                <small>PCS</small>
              </div>
              <b class="fw-600 d-inlineblock">
                <!-- {{ totalBaggageWeight }} -->
                <small>
                  {{
                    flight.BagTotals[0]
                      ? flight.BagTotals[0].WeightUnit.toUpperCase()
                      : ''
                  }}
                </small>
              </b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="paxTotalsView === 'checked'">
      <h6 style="margin: 0">Checked Pax Totals</h6>
      <table class="table totals table-hover small-table mt-1">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col" class="br">A</th>
            <th scope="col" class="br">C</th>
            <th scope="col" class="br">I</th>
            <th scope="col">BAG</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bt no-hover">
            <td rowspan="5" class="bt no-hover">TOTAL</td>
          </tr>
          <tr>
            <td class="br">{{ ACI['A'] || '0' }}</td>
            <td class="br">{{ ACI['C'] || '0' }}</td>
            <td class="br">{{ ACI['I'] || '0' }}</td>
            <td>
              <div class="fw-600">
                <!-- {{ totalBaggage }} -->
                <small>PCS</small>
              </div>
              <b class="fw-600 d-inlineblock">
                <!-- {{ totalBaggageWeight }} -->
                <small>
                  {{
                    flight.BagTotals[0]
                      ? flight.BagTotals[0].WeightUnit.toUpperCase()
                      : ''
                  }}
                </small>
              </b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <hr>

    <div class="totals-row text-right text-monospace">
      BAY SPLIT
      <b class="text-info">{{
        flight.SeatAllocation === 'FREE' ? 'FREE SEATING' : null
      }}</b>
      <div
        v-for="(item, key, index) in baySplitTotals"
        :key="index"
        class="mr-2"
      >
        {{ key }}/<b>{{ item }}</b>
      </div>
    </div>

    <div class="text-right text-monospace mt-3">
      <p class="mt-1 text-uppercase" v-if="flight.SeatAllocation !== 'FREE'"
        >Destination/Bay Split</p
      >
      <hr />
      <div class="text-right text-monospace">
        <div v-for="(item, key, index) in flight.BagTotals" :key="index">
          <b>{{ item.Destination }}</b> BAGS
          <b>
            {{ item['TotalPieces'] }} / {{ item['TotalWeight'] }}
            <small>{{ item.WeightUnit.toUpperCase() }}</small>
          </b>
        </div>
      </div>
    </div>

    <table
      class="table table-hover totals mt-4"
      v-if="flight.SeatAllocation !== 'FREE'"
    >
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col" class="br"></th>
          <th scope="col" class="br">M</th>
          <th scope="col" class="br">F</th>
          <th scope="col" class="br">C</th>
          <th scope="col">I</th>
        </tr>
      </thead>

      <tbody
        v-for="(dest, key, topIdx) in groupedDestBayMFCI"
        :key="topIdx"
        class
      >
        <tr class="no-hover">
          <td rowspan="15" class="fw-600">{{ key }}</td>
        </tr>
        <tr v-for="(bay, childIdx) in dest" :key="childIdx">
          <td class="br">{{ bay.BayNumber }}</td>
          <td class="br">{{ getReducedMFCI([bay])['M'] }}</td>
          <td class="br">{{ getReducedMFCI([bay])['F'] }}</td>
          <td class="br">{{ getReducedMFCI([bay])['C'] }}</td>
          <td class>{{ getReducedMFCI([bay])['I'] }}</td>
        </tr>
      </tbody>

      <tbody>
        <tr class="no-hover">
          <td rowspan="5" class="bt">TOTAL</td>
        </tr>
        <tr>
          <td class="br bt"></td>
          <td class="br bt fw-600">{{ MFCI['M'] || '0' }}</td>
          <td class="br bt fw-600">{{ MFCI['F'] || '0' }}</td>
          <td class="br bt fw-600">{{ MFCI['C'] || '0' }}</td>
          <td class="bt fw-600">{{ MFCI['I'] || '0' }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="6" class="text-right"><small>* Above figures are checked totals</small></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<style scoped>
.totals-row {
  display: flex;
  justify-content: space-evenly;
}
</style>
